import React, { useEffect } from "react";
import { PaymentsListTable } from "../../../components/table/table_paymentslist";

const PaymentList = ({ callBack }) => {

    return (
        <div className="container-fluid payments-component">
            <div className="row">
                <div className="col">
                    <h1 className="title">{gettext('Payments')}</h1>
                </div>
            </div>
            <PaymentsListTable callBack={callBack} />
        </div>
    )

}

export default PaymentList